import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  message,
  Select,
  Typography,
  Row,
  Col,
  Upload,
  Spin,
} from "antd"
import { addDoc, collection, onSnapshot, query, serverTimestamp, where } from "firebase/firestore"
import React, { useEffect, useState } from "react"
import { db, storage } from "../../../firebase/config"
import { PlusCircleOutlined, UploadOutlined } from "@ant-design/icons"
import { useCollection } from "../../../hooks/useCollection"
import { ref as storageRef, uploadBytes } from "firebase/storage"

// import axios from "axios"

const { Link, Title, Text } = Typography
const { TextArea } = Input

export default function NewTapePlateModal(props) {
  const { data: clientList, loading: clientListLoading } = useCollection("clients")

  //init form
  const [form] = Form.useForm()

  //technical page file
  const [filesList, setFilesList] = useState([])

  //create button loading
  const [buttonLoading, setButtonLoading] = useState(false)

  //loading
  const [loading, setLoading] = useState(false)

  //product list
  const [productList, setProductList] = useState([])
  const [productListLoading, setProductListLoading] = useState(false)

  const [fileList, setFileList] = useState([])
  const [folderName, setFolderName] = useState("")

  const plateFolder = "tapePlates"

  const beforeUpload = (file) => {
    setFileList([...fileList, file])
    // Prevent automatic upload
    return false
  }

  //main data object
  const [dataObject, setDataObject] = useState({
    clientId: null,
    client: null,
    code: null,
    codeNumber: null,
    codePrefix: null,
    important: "none",
    layoutDesign: null,
    product: null,
    productId: null,
    rows: null,
    designerProductName: null,
    plateLocation: null,
    machine: "tape",
    plateRef: "tapePlatesList",
    storageRef: "tapePlates",
  })

  const [openDrawer, setOpenDrawer] = useState(false)
  const showDrawer = () => {
    setOpenDrawer(true)
  }
  const onClose = () => {
    setOpenDrawer(false)
  }

  const onFinish = (values) => {
    console.log("Success:", values)
    createNewPlate()
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  //gets products
  useEffect(() => {
    setProductListLoading(true)
    const priceRef = collection(db, "tapePrices")
    let q = query(priceRef, where("clientId", "==", dataObject.clientId))

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        const data = doc.data()
        results.push({ ...data, key: doc.id, id: doc.id })
      })
      // sort the results based on the arsomaSequence state
      setProductList(results)
      setProductListLoading(false)
    })

    return () => unsubscribe()
  }, [dataObject.clientId])

  // //upload to nextcloud
  // const handleUpload = async (fileList, folderName, plateFolder) => {
  //   const promises = fileList.map((file) => {
  //     return new Promise((resolve, reject) => {
  //       const reader = new FileReader()
  //       reader.readAsDataURL(file)
  //       reader.onload = () => {
  //         const fileData = reader.result.split(",")[1]
  //         axios
  //           .post("https://us-central1-managers-testing.cloudfunctions.net/uploadFileNextCloud", {
  //             folderName,
  //             fileName: file.name,
  //             fileData,
  //             plateFolder,
  //           })
  //           .then((response) => {
  //             if (response.data.success) {
  //               message.success(`${file.name} uploaded successfully`)
  //               resolve()
  //             } else {
  //               message.error(`${file.name} upload failed.`)
  //               reject(new Error("Upload failed"))
  //             }
  //           })
  //           .catch((error) => {
  //             message.error(`${file.name} upload failed.`)
  //             reject(error)
  //           })
  //       }
  //       reader.onerror = (error) => reject(error)
  //     })
  //   })

  //   await Promise.all(promises)
  // }

  const handleUpload = async (fileList, folderName, plateFolder) => {
    const uploadPromises = fileList.map((file) => {
      return new Promise((resolve, reject) => {
        const fileRef = storageRef(storage, `${plateFolder}/${folderName}/${file.name}`) // Create a reference to the file location
        uploadBytes(fileRef, file) // Upload the file
          .then((snapshot) => {
            message.success(`${file.name} uploaded successfully`)
            resolve(snapshot)
          })
          .catch((error) => {
            message.error(`${file.name} upload failed: ${error.message}`)
            reject(error)
          })
      })
    })

    await Promise.all(uploadPromises)
  }

  //new plate creation
  const createNewPlate = async () => {
    try {
      setButtonLoading(true)
      setLoading(true) // Set loading state to true when the function starts executing

      // First, upload all files
      await handleUpload(fileList, folderName, plateFolder)

      // Once all uploads are complete, add the document
      const collectionRef = collection(db, "tapePlatesList")
      await addDoc(collectionRef, {
        ...dataObject,
        created: serverTimestamp(),
        updated: serverTimestamp(),
      })
      message.success("New plate added!")
    } catch (error) {
      console.error("Error:", error)
      message.error(error.message)
    } finally {
      setFilesList([])
      setOpenDrawer(false)
      form.resetFields()
      setButtonLoading(false)
      setLoading(false) // Reset loading state to false once everything is done
    }
  }

  //handle select for client
  const handleClientSelect = (value, option) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      client: option.client,
      clientId: option.id,
    }))
    form.resetFields(["product"])
  }

  //handle select for product
  const handleProductSelect = (value, option) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      product: value,
      productId: option.id,
    }))
  }

  //handle change for code input
  const handleCodeChange = (value) => {
    const totalCode = "POLI" + value

    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      code: "LIM" + value,
      codeNumber: value,
      codePrefix: "LIM",
    }))
    setFolderName(totalCode)
  }

  //get last knife plate code
  const buttonForLast = () => <Link onClick={getLastCode}>Get last</Link>
  const getLastCode = () => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      codeNumber: props.lastPlate.codeNumber + 1,
      code: "LIM" + (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"),
      codePrefix: "LIM",
    }))
    setFolderName("LIM" + (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"))
    form.setFieldValue("code", (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"))
  }

  //handles plate rows
  const handlePlateRows = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      rows: value,
    }))
  }

  //handles layout name
  const handleLayoutName = (event) => {
    const value = event.target.value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      layoutDesign: value,
    }))
  }

  //handle comment
  const handleComment = (event) => {
    const value = event.target.value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      important: value,
    }))
  }

  //handle designer name
  const handleDesignerName = (event) => {
    const value = event.target.value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      designerProductName: value,
    }))
  }

  //handles plate location
  const handlePlateLocation = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      plateLocation: value,
    }))
  }

  //returns uploading state
  const returnLoadingState = () => {
    if (loading) {
      return (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(255,255,255,0.9)", // white with 50% opacity
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 15,
          }}>
          <div>
            <Row>
              <Col span={24}>
                <Title>
                  <Spin /> Files being uploaded
                </Title>
              </Col>
            </Row>

            {filesList &&
              filesList.map((file) => (
                <div key={file.uid}>
                  <Text italic>{file.name}</Text>
                </div>
              ))}
          </div>
        </div>
      )
    }
  }

  return (
    <>
      <Button onClick={showDrawer}>
        New tape plate <PlusCircleOutlined />
      </Button>
      <Drawer
        width={700}
        title="New viva plate"
        placement="right"
        onClose={onClose}
        open={openDrawer}>
        {returnLoadingState()}
        <Form
          form={form}
          initialValues={{
            remember: true,
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ width: "100%" }}>
          <Form.Item
            label="Select client"
            name="client"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              showSearch
              placeholder="Select client"
              optionFilterProp="children"
              onChange={handleClientSelect}
              fieldNames={{ label: "client", value: "id", key: "id" }}
              loading={clientListLoading}
              filterOption={(input, option) =>
                (option?.client ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={clientList && clientList}
            />
          </Form.Item>
          <Form.Item
            label="Select product"
            name="product"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              showSearch
              placeholder="Select product"
              optionFilterProp="children"
              onChange={handleProductSelect}
              loading={productListLoading}
              filterOption={(input, option) =>
                (option?.product?.productName ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={
                productList &&
                productList.map((option, index) => ({
                  label: option?.product?.productName,
                  value: option?.product?.productName,
                  key: index,
                  id: option.id,
                }))
              }
            />
          </Form.Item>
          <Form.Item label="Designer product name (optional)" name="designerProductName">
            <Input
              placeholder="Write your own product slogan"
              style={{ width: "100%" }}
              onChange={handleDesignerName}
            />
          </Form.Item>
          <Form.Item
            label="Plate Code"
            name="code"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <InputNumber
              style={{ width: "100%" }}
              addonAfter={buttonForLast()}
              prefix="LIM"
              min={0}
              onChange={handleCodeChange}
            />
          </Form.Item>
          <Form.Item
            label="Plate rows"
            name="rows"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <InputNumber style={{ width: "100%" }} min={0} max={100} onChange={handlePlateRows} />
          </Form.Item>
          <Form.Item
            label="Layout Name"
            name="layoutName"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Input style={{ width: "100%" }} onChange={handleLayoutName} />
          </Form.Item>
          <Form.Item
            label="Plate Location"
            name="plateLocation"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              onChange={handlePlateLocation}
              options={[
                {
                  value: "Not Ordered",
                  label: "Not Ordered",
                },
                {
                  value: "Ordered",
                  label: "Ordered (in proccess)",
                },
                {
                  value: "Kengarags",
                  label: "At Kengarags",
                },
                {
                  value: "Visvaldis",
                  label: "At Visvaldis",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="All files regarding this plate"
            name="filesList"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Upload
              beforeUpload={beforeUpload}
              fileList={fileList}
              onRemove={(file) => {
                setFileList(fileList.filter((item) => item.uid !== file.uid))
              }}>
              <Button icon={<UploadOutlined />}>Select Files</Button>
            </Upload>
          </Form.Item>
          <Form.Item
            label="Important"
            name="important"
            rules={[
              {
                message: "Please input your field!",
              },
            ]}>
            <TextArea rows={4} style={{ width: "100%" }} onChange={handleComment} />
          </Form.Item>
          <Form.Item>
            <Button block type="primary" loading={buttonLoading} htmlType="submit">
              Create plate
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  )
}
